import "prebid.js/modules/optidigitalBidAdapter"

import type {IPrebidJsBidder} from "header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/iPrebidJsBidder";
import type {HeaderBiddingConfig} from "header-bidding-client-base/modules/config/domain/headerBiddingConfig";
import {Bidders} from "header-bidding-base/modules/header-bidding/domain/bidders";
import {PrebidJsBaseBidder} from "./prebidJsBaseBidder";
import {OptidigitalAdUnit} from "header-bidding-base/modules/config/domain/bidders/optidigitalConfig";

export class OptidigitalBidder extends PrebidJsBaseBidder implements IPrebidJsBidder<OptidigitalAdUnit> {
    public constructor(config: HeaderBiddingConfig) {
        super(config, Bidders.OPTIDIGITAL);
    }
}
